export default "__VITE_ASSET__CCYUqRrh__"